"use client";

import React from "react";
import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards, { ServiceCardItem } from "@/components/service/ServiceCards";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import NewRoofsQuoteSection from "./sections/NewRoofsQuoteSection";
import { House, Layers, Sparkles, CloudRain, Flame, BrickWall } from "lucide-react";
const newRoofServices: ServiceCardItem[] = [{
  title: "Traditional Pitched Roofs",
  description: "Complete pitched roof installations using slate and tiles, delivering long-lasting weather protection and timeless kerb appeal across Southampton.",
  icon: House
}, {
  title: "Modern Flat Roofs",
  description: "High-performance flat roofing systems including EPDM rubber and fibreglass, installed by our specialist roofing team in Southampton.",
  icon: Layers,
  to: "/FlatRoofsPage"
}, {
  title: "Slate & Tile Roofing",
  description: "Precision-installed natural slate and interlocking clay tiles matched to Hampshire architectural styles and coastal weather demands.",
  icon: Sparkles
}, {
  title: "Complete Roofline & Drainage",
  description: "Fascias, soffits, and guttering integrated with your new roof installation to direct rainwater efficiently and prevent damp.",
  icon: CloudRain
}, {
  title: "Commercial Roof Installation",
  description: "Robust commercial new roof installations for premises in Southampton and surrounding areas, executed with strict safety standards.",
  icon: Flame
}, {
  title: "Bespoke Structural Detailing",
  description: "Structural timber rafter works, breathable dry-ridge systems, lead flashing, and valley work to ensure leak-free integrity.",
  icon: BrickWall
}];
export default function NewRoofsPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="New Roofs" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="New Roofs in Southampton" intro="Specialist new roof installations designed for longevity, aesthetic appeal, and superior weather protection. Serving Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/bright_new_roof.png" imageAlt="New roof installation in Southampton by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="EXPERT INSTALLATION" heading="Expert New Roof Installation in Southampton" paragraphs={["Looking for professional roofing services in Southampton? Firststop Roofing Ltd delivers complete new roof installations for homeowners across Southampton, Eastleigh, Romsey, Totton, and all nearby Hampshire towns.", "Our experienced team combines time-tested craftsmanship with modern high-performance materials to construct weatherproof, energy-efficient roofs. Whether you need a full replacement for an ageing roof or a brand new build, our roofers in Southampton ensure lasting structural protection and superb kerb appeal."]} benefits={["Premium slate, clay tile, and modern composite systems", "Engineered for coastal Hampshire weather resistance and durability", "Complete timber, breathable membrane, and ventilation installation"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/new-roof-work.jpg?v=mt34xrimrx" imageAlt="Slate and tile new roof installation in Southampton by Firststop Roofing Ltd" cta={true} />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Our New Roof Services in Southampton" intro="Complete pitched and flat new roof solutions tailored to properties across Southampton, Hampshire & surrounding areas." items={newRoofServices} columns={3} />

      <NewRoofsQuoteSection />

      <OtherServices currentKey="new-roofs" />

      <CtaBand />

      <Footer />
    </div>;
}